'use strict';

var _ = require('lodash');
var StrategyHelper = function StrategyHelper(seasonColorService) {
  function getFillData(quickFilterData, season, dowGroup, conditionFunc) {
    return {
      color: seasonColorService.getColor(season),
      isVisible: conditionFunc(quickFilterData, season, dowGroup)
    };
  }
  return {
    getFillData: getFillData
  };
};
StrategyHelper.$inject = ['SeasonColorService'];
module.exports = StrategyHelper;